import React, { useRef } from 'react'
import { RxCaretRight, RxCaretLeft, RxCaretDown } from 'react-icons/rx'
import { BlocksRenderer } from '@strapi/blocks-react-renderer'
import { HtmlTag } from '../libs/helpers'
import * as styles from './tabs.module.scss'

const TimeLineTabView = ({
  theme,
  setActiveTab,
  footer,
  title,
  description,
  tabItem,
  activeTab,
  handleTabClick,
  isDropdownActive,
  setIsDropdownActive,
}) => {
  const tabWrapperRef = useRef(null)
  const toggleDropdown = () => {
    setIsDropdownActive(!isDropdownActive)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      toggleDropdown()
    }
  }

  const handleDirectionButtonClick = (direction, event) => {
    if (direction === 'next') {
      setActiveTab((prevActiveTab) => (prevActiveTab + 1) % tabItem.length)
    } else if (direction === 'prev') {
      setActiveTab((prevActiveTab) => (prevActiveTab === 0 ? tabItem.length - 1 : prevActiveTab - 1))
    }
    if (tabWrapperRef.current) {
      tabWrapperRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  const nextTabTitle = tabItem[(activeTab + 1) % tabItem.length].title || tabItem[(activeTab + 1) % tabItem.length].copy
  const prevTabTitle =
    tabItem[activeTab === 0 ? tabItem.length - 1 : activeTab - 1].title ||
    tabItem[activeTab === 0 ? tabItem.length - 1 : activeTab - 1].copy

  return (
    <>
      {theme === 'timeline' && (
        <div className={styles['timelineTabSection']}>
          <div className={styles['container']}>
            <div className={styles['headerText']} ref={tabWrapperRef}>
              <div className={styles['smallContainer']}>
                {title && <HtmlTag tagName={title.header}>{title.copy}</HtmlTag>}
                <BlocksRenderer content={description} />
              </div>
            </div>

            <div className={styles['tabsLinkWrapper'] + (isDropdownActive ? ` ${styles['active']}` : '')}>
              <div className={styles['tabsDropdownList']}>
                <div
                  className={styles['mobileYear']}
                  onClick={toggleDropdown}
                  onKeyDown={handleKeyDown}
                  tabIndex={0}
                  role="button"
                >
                  {tabItem.map((item, index) => index === activeTab && item.title)}
                  <RxCaretDown className={isDropdownActive ? `${styles['rotate_up']}` : `${styles['rotate_down']}`} />
                </div>
                <div className={styles['yearLinks']}>
                  {tabItem.map((item, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        handleTabClick(index)
                        setIsDropdownActive(false)
                      }}
                      className={`${index === activeTab ? styles.active : ''}`}
                    >
                      <span>{item.title}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className={styles['yearContent']}>
              <div className={styles['smallContainer']}>
                {tabItem.map((item, index) => (
                  <div
                    id={`tab-${index + 1}`}
                    className={`${styles.tab}`}
                    key={index}
                    style={{ display: index === activeTab ? 'block' : 'none' }}
                  >
                    <div className={styles['contentStyles']}>
                      <BlocksRenderer content={item.description} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className={styles['nextPrevWrapper']}>
              <div className={styles['smallContainer']}>
                <div className="prev">
                  <span
                    className={styles['prevText']}
                    data-direction="prev"
                    onClick={(event) => handleDirectionButtonClick('prev', event)}
                    onKeyDown={(event) => handleKeyDown(event, 'prev')}
                    tabIndex={0}
                    role="button"
                  >
                    <RxCaretLeft />
                    {prevTabTitle}
                  </span>
                </div>
                <div className="next">
                  <span
                    className={`${styles['nextText']}`}
                    data-direction="next"
                    onClick={(event) => handleDirectionButtonClick('next', event)}
                    onKeyDown={(event) => handleKeyDown(event, 'prev')}
                    tabIndex={0}
                    role="button"
                  >
                    {nextTabTitle}
                    <RxCaretRight />
                  </span>
                </div>
              </div>
            </div>
            <div className={styles['footerText']}>
              <div className={styles['smallContainer']}>
                <div className={styles['timeline_footer_text']}>
                  <BlocksRenderer content={footer} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default TimeLineTabView
